import { z } from "zod";
import { sessionIdSchema } from "./sessions.js";
export const listWorkspaceSessionReadStatesQuerySchema = z.object({
    sessionIds: z.array(sessionIdSchema).min(1).max(100),
});
export const workspaceSessionReadStateSchema = z.object({
    sessionId: sessionIdSchema,
    unread: z.boolean(),
    manuallyUnread: z.boolean(),
});
export const listWorkspaceSessionReadStatesResponseSchema = z.object({
    states: z.array(workspaceSessionReadStateSchema),
});
export const workspaceSessionReadStateParamsSchema = z.object({
    sessionId: sessionIdSchema,
});
export const putWorkspaceSessionReadStateRequestSchema = z.object({
    unread: z.boolean(),
}).strict();
export const workspaceSessionReadStateResponseSchema = z.object({
    state: workspaceSessionReadStateSchema,
});
